import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const PlayerMovementCard = ({ movement }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-5 hover:shadow-md transition-shadow duration-300">
      <div className="flex items-start gap-3 md:gap-4 mb-4">
        <div className="relative flex-shrink-0">
          <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden border-2 border-border">
            <Image
              src={movement?.playerImage}
              alt={movement?.playerImageAlt}
              className="w-full h-full object-cover"
            />
          </div>
          <div className={`absolute -bottom-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center ${
            movement?.status === 'completed' ? 'bg-success' : movement?.status === 'pending' ? 'bg-warning' : 'bg-muted'
          }`}>
            <Icon name={movement?.status === 'completed' ? 'Check' : movement?.status === 'pending' ? 'Clock' : 'AlertCircle'} size={14} color="white" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">{movement?.playerName}</h4>
          <p className="text-xs text-muted-foreground mb-2">{movement?.position} • {movement?.age} years</p>
          <div className="flex items-center gap-2 text-xs md:text-sm">
            <span className="text-muted-foreground">{movement?.fromClub}</span>
            <Icon name="ArrowRight" size={14} color="var(--color-primary)" />
            <span className="text-foreground font-medium">{movement?.toClub}</span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between pt-3 border-t border-border">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Transfer Value</p>
          <p className="text-sm md:text-base font-bold text-foreground">{movement?.value}</p>
        </div>
        <div className="text-right">
          <p className="text-xs text-muted-foreground mb-1">Date</p>
          <p className="text-sm md:text-base font-medium text-foreground">{movement?.date}</p>
        </div>
      </div>
    </div>
  );
};

export default PlayerMovementCard;